import { ReactComponent as RemoveFromCompareIcon } from './remove_from_compare.svg';

export default RemoveFromCompareIcon;
